// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2H20V16H5.82046L1 19.4432V2ZM23.5 4.5V22.9432L18.6795 19.5H7.5V17.5H19.3205L21.5 19.0568V4.5H23.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-double-filled')
export default class ChatDoubleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-double-filled',
    }
  }
}
